import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Modules, useLoggedInUserPermissions } from '~/components/Auth';
import { WithPerspectives } from '~/components/MyWorkspace/ManagePerspectives';
import { TableWidgetComponentFactory } from '~/components/MyWorkspace/TableWidget';
import { RewardingTabs } from '~/data/tabs';
import { People } from '~/services/Http';
import { useGetEmployeePerformanceScores } from '~/services/Http/hooks/people/useGetEmployeeCurrentPerformanceScores';

import { WidgetProps } from '../../data/widgets';

import { MyPerformance } from './components/MyPerformance/component';
import { TableHeader } from './components/TableHeader';

export interface MyPerformanceWidgetProps
  extends WidgetProps<WithPerspectives> {}

const MyPerformanceWidgetComponent = TableWidgetComponentFactory({
  TableRowComponent: MyPerformance,
  getIdentifier: (item: People.PerformanceGoalFullDto) => `${item.id}`,
  TableHeaderComponent: TableHeader,
  dataCy: 'my-performance-widget',
  allTableDialogProps: {
    maxWidth: 'lg',
    fullWidth: true,
  },
});

export const MyPerformanceWidget: React.FC<MyPerformanceWidgetProps> = ({
  title,
}) => {
  const { t } = useTranslation();

  const {
    data: performance,
    loading,
    failedToLoad,
  } = useGetEmployeePerformanceScores({
    employeeId: 'me',
  });

  const permissions = useLoggedInUserPermissions();
  const rewardingModuleEnabledTabs = permissions.enabledTabs[Modules.REWARDING];

  return (
    <MyPerformanceWidgetComponent
      title={title || t('myPerformance')}
      data={performance ? [performance] : []}
      loading={loading}
      failedToLoad={failedToLoad}
      noDataMessage={t('noPerformance')}
      isTabDisabled={
        !!rewardingModuleEnabledTabs &&
        !rewardingModuleEnabledTabs.includes(RewardingTabs.GENERAL)
      }
    />
  );
};
